<app-wait *ngIf="!doneLoading" waitText="Please wait while we lookup your {{accountRecovery ? 'account recovery' :
    'reset password'}} request."></app-wait>

<div *ngIf="doneLoading" class="suif-panel reset-password" (appOnEnter)="submit()">

    <h1 class="suif-panel-title-dark">{{title}}</h1>

    <div class="reset-password-info">

        <app-message-box *ngIf="errors.validationErrors" validationError></app-message-box>
        <app-message-box *ngIf="errors.unexpectedError" unexpectedError></app-message-box>

        <div *ngIf="errors.loadingError">
            <div class="error-container">
                <img src="/images/sad-cloud.svg" alt="">
                <div>{{errors.loadingError}}</div>

                <div *ngIf="showLinkToTryAgain">
                    <a routerLink="/forgotPassword">Try again to reset your password</a>
                </div>
            </div>
        </div>

        <div *ngIf="errors.accountRecoveryLoadingError">
            <div class="error-container">
                <img src="/images/sad-cloud.svg" alt="">
                <div>
                    This account recovery request is no longer valid.  If you already activated your email, please try
                    to <a routerLink="/login">sign in</a>.
                </div>
            </div>
        </div>

        <div *ngIf="doneLoading && validToken">

            <h3 class="suif-h3">Welcome! There's just one more step.</h3>

            <p class="suif-body-copy-small">Enter your new password, then you can log in to your account.</p>

            <app-password-update [(ngModel)]="newPassword"
                                 passwordLabel="New Password" passwordFieldId="new-password"
                                 [passwordErrors]="errors.fieldErrors.newPassword"
                                 confirmLabel="Confirm New Password" passwordFieldId="confirm-new-password"
                                 [confirmErrors]="errors.fieldErrors.confirmNewPassword">
            </app-password-update>

            <div *ngIf="!signedTermsOfService" class="tos-checkbox">
                <app-checkbox [(ngModel)]="termsAccepted" isRequired [errors]="errors.fieldErrors.termsAccepted">
                    I acknowledge that I have read and agree to the
                </app-checkbox>
                <button type="button" class="button-link" (click)="openTermsOfService()">Terms & Conditions</button>
            </div>

            <div class="button-row">
                <app-wait-button (onClick)="submit()" cssClass="btn btn-verty" [waiting]="submitting" label="Continue"
                                   [isDisabled]="isContinueDisabled()"></app-wait-button>
            </div>
        </div>
    </div>
</div>
